import { useState } from 'react';
import styles from './Games.module.css';

interface GameConfig {
	id: string;
	name: string;
	enabled: boolean;
	houseEdge: number;
	minBet: string;
	maxBet: string;
	totalBets: number;
	totalGGR: string;
}

const mockGames: GameConfig[] = [
	{ id: 'dice', name: 'Dice', enabled: true, houseEdge: 1, minBet: '$0.10', maxBet: '$10,000', totalBets: 125000, totalGGR: '$12,500' },
	{ id: 'plinko', name: 'Plinko', enabled: true, houseEdge: 1, minBet: '$0.10', maxBet: '$5,000', totalBets: 85000, totalGGR: '$8,500' },
	{ id: 'crash', name: 'Crash', enabled: false, houseEdge: 1, minBet: '$0.10', maxBet: '$10,000', totalBets: 0, totalGGR: '$0' },
	{ id: 'coinflip', name: 'Coin Flip', enabled: false, houseEdge: 2, minBet: '$1.00', maxBet: '$5,000', totalBets: 0, totalGGR: '$0' },
];

export default function Games() {
	const [games, setGames] = useState<GameConfig[]>(mockGames);

	const toggleGame = (id: string) => {
		setGames(games.map((g) => (g.id === id ? { ...g, enabled: !g.enabled } : g)));
	};

	return (
		<div className={styles.games}>
			<header className={styles.header}>
				<div>
					<h1 className={styles.title}>Games</h1>
					<p className={styles.subtitle}>Configure games for your players</p>
				</div>
			</header>

			<div className={styles.gamesGrid}>
				{games.map((game) => (
					<div key={game.id} className={`${styles.gameCard} ${!game.enabled ? styles.disabled : ''}`}>
						<div className={styles.gameHeader}>
							<div className={styles.gameIcon}>
								<GameIcon type={game.id} />
							</div>
							<label className={styles.toggle}>
								<input type="checkbox" checked={game.enabled} onChange={() => toggleGame(game.id)} />
								<span className={styles.toggleSlider}></span>
							</label>
						</div>
						<h3 className={styles.gameName}>{game.name}</h3>

						<div className={styles.gameDetails}>
							<div className={styles.gameDetail}>
								<span className={styles.detailLabel}>House Edge</span>
								<span className={styles.detailValue}>{game.houseEdge}%</span>
							</div>
							<div className={styles.gameDetail}>
								<span className={styles.detailLabel}>Min Bet</span>
								<span className={styles.detailValue}>{game.minBet}</span>
							</div>
							<div className={styles.gameDetail}>
								<span className={styles.detailLabel}>Max Bet</span>
								<span className={styles.detailValue}>{game.maxBet}</span>
							</div>
						</div>

						{game.enabled && (
							<div className={styles.gameStats}>
								<div className={styles.gameStat}>
									<span className={styles.statValue}>{game.totalBets.toLocaleString()}</span>
									<span className={styles.statLabel}>Bets</span>
								</div>
								<div className={styles.gameStat}>
									<span className={styles.statValue}>{game.totalGGR}</span>
									<span className={styles.statLabel}>GGR</span>
								</div>
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
}

function GameIcon({ type }: { type: string }) {
	switch (type) {
		case 'dice':
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
					<rect x="3" y="3" width="18" height="18" rx="2" />
					<circle cx="8" cy="8" r="1.5" fill="currentColor" />
					<circle cx="16" cy="16" r="1.5" fill="currentColor" />
					<circle cx="12" cy="12" r="1.5" fill="currentColor" />
				</svg>
			);
		case 'plinko':
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
					<circle cx="12" cy="4" r="2" />
					<circle cx="6" cy="10" r="1.5" />
					<circle cx="12" cy="10" r="1.5" />
					<circle cx="18" cy="10" r="1.5" />
					<path d="M3 22h18" />
				</svg>
			);
		case 'crash':
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
					<path d="M3 17l6-6 4 4 8-11" />
					<path d="M17 4h4v4" />
				</svg>
			);
		default:
			return (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
					<circle cx="12" cy="12" r="10" />
					<path d="M12 6v2M12 16v2" />
				</svg>
			);
	}
}
